<app-main-layout [clickBack]="onClickBack" [disableWatchingRoutes]="true">
  <div class="main-heading">
    <h2>Window Nation’s Installation Process</h2>
    <div class="cs-inner-html-16">
      <p>Here’s what you can expect when you choose Window Nation for your window/door replacement project <em>(click each tile to find out more)</em>:</p>
    </div>
  </div>
  <div class="accordion">
    @for (item of installationProcess; track item) {
      <div class="item" [ngClass]="{'active': item.active}" (click)="toggleItem(item)">
        <div class="heading">
          <strong class="title">{{item.title}}</strong>
          <strong class="subtitle">{{item.subtitle}}</strong>
        </div>
        <div class="expanded-block" [innerHtml]="item.text"></div>
      </div>
    }
  </div>
</app-main-layout>